export default {
  lang: "ภาษาไทย",
  //general
  MEA: "การไฟฟ้านครหลวง",
  MEAtitle: "การไฟฟ้านครหลวง",
  Name: "ชื่อ",
  Lastname: "นามสกุล",
  Email: "อีเมล",
  Tel: "เบอร์ติดต่อ",
  Subject: "เรื่อง",
  Company: "ชื่อหน่วยงาน/องค์กร/บริษัท",
  Website: "เว็บไซต์",
  Requirement: "รายละเอียด",
  Signout: "ออกจากระบบ",
  Cancel: "ยกเลิก",
  TermPrivacy: "Term & Privacy",
  PrivacyPolicy: "นโยบายความเป็นส่วนตัว",
  Terms: "ข้อตกลงและเงื่อนไข",
  Privacy: "ความเป็นส่วนตัว",
  District: "อำเภอ",
  Subdistrict: "ตำบล",
  City: "จังหวัด",
  Country: "ประเทศ",
  Zipcode: "รหัสไปษณีย์",
  Password: "รหัสผ่าน",
  Accesstoken: "API Key",
  SigninMEA: "MEA Smart Office",
  And: "และ",
  BySignin: "เมื่อลงชื่อเข้าใช้ระบบคุณได้ยอมรับ",
  ConfirmPassword: "ยืนยันรหัสผ่าน",
  Next: "ถัดไป",
  Account: "บัญชี",
  Back: "ย้อนกลับ",
  Finish: "เสร็จสิ้น",
  SaveChange: "บันทึกการเปลี่ยนแปลง",
  UserProfile: "ข้อมูลส่วนตัว",
  APIConsole: "ควบคุม API",
  January: "มกราคม",
  February: "กุมภาพันธ์",
  March: "มีนาคม",
  April: "เมษายน",
  May: "พฤษภาคม",
  June: "มิถุนายน",
  July: "กรกฏาคม",
  August: "สิงหาคม",
  September: "กันยายน",
  October: "ตุลาคม",
  November: "พฤศจิกายน",
  December: "ธันวาคม",
  Delete: "ลบ",
  Update: "บันทึก",
  Save: "บันทึก",
  NoPermission: "ไม่ได้รับอนุญาตในการแก้ไข",
  onSave: "กำลังบันทึกการเปลี่ยนแปลง",
  Contract: "สัญญา",
  No: "ลำดับ",
  Filter: "ค้นหา",
  Rows: "แถว",
  Individual: "สรุปการใช้งานส่วนบุคคล",
  Seachforname: "ค้นหาชื่อผู้ใช้และป้อนรายละเอียดเพื่อดูรายงาน",
  Date: "วันที่",
  Time: "เวลา",
  FirstPage: "หน้าแรก",
  PreviousPage: "ก่อนหน้า",
  NextPage: "หน้าต่อไป",
  LastPage: "หน้าสุดท้าย",
  YouHave: "คุณมี",
  Pendingtask: "การแจ้งเตือน",
  ViewAll: "ดูทั้งหมด",
  Clear: "ล้าง",
  Edit: "แก้ไข",
  LoginSuccessfully: "เข้าสู่ระบบเรียบร้อยแล้ว",
  LogingIn: "กำลังเข้าสู่ระบบ",
  LogoutSuccessfully: "ออกจากระบบแล้ว",
  SignupSuccess: "โปรดเช็คอีเมลของคุณเพื่อยืนยันบัญชี",
  Norecord: "ไม่พบข้อมูล",
  IncorrectEmail: "อีเมลหรือรหัสผ่านไม่ถูกต้อง",
  AddressMEA:
    "ฝ่ายพัฒนาระบบงานประยุกต์ การไฟฟ้านครหลวง เขตยานนาวา อาคาร 1 ชั้น 6  3027 ถ.เจริญกรุง แขวงบางคอแหลม เขตบางคอแหลม กรุงเทพฯ 10120",
  NotFound: "ไม่พบข้อมูล",
  MonthlyUsage: "การใช้งานรายเดือน",
  Error: "ผิดพลาด",
  Success: "สำเร็จ",
  Activate: "ยืนยันบัญชี",

  //subhome
  MEAsubtitle:
    "ต่อยอดพัฒนาธุรกิจ พร้อมสร้างคุณค่าและมูลค่าให้กับข้อมูลแผนที่ฐานและระบบไฟฟ้า ",
  SubtitlesExclusiveService: "",
  SubtitlesAboutMEA:
    "การไฟฟ้านครหลวงได้พัฒนาฐานข้อมูล GIS ความละเอียดสูง ในพื้นที่กรุงเทพมหานคร นนทบุรี และสมุทรปราการ เป็นเวลา 20 กว่าปี อันประกอบด้วยข้อมูลแผนที่ฐาน และระบบไฟฟ้าที่มีความละเอียดถูกต้องใน ในเขตรับผิดชอบ 3 จังหวัด ได้แก่ กรุงเทพมหานคร นนทบุรี และสมุทรปราการ เพื่อตอบสนองการใช้งานทั้งหน่วยงานภายใน และหน่วยงานภายนอก ต่อมามีแนวคิดที่จะขยายการให้บริการข้อมูลแผนที่ออกสู่ประชาชน และหน่วยงานอืนๆให้มากยิ่งขึ้น จึงเป็นจุดเริ่มต้นของการให้บริการ MEA Map API  เพื่อเปิดโอกาสให้ประชาชนได้ร่วมใช้งานข้อมูลสารสนเทศภูมิศาสตร์ ที่มีความละเอียดสูงนี้",
  SubtitlesOurAPI:
    "รูปแบบบริการ API เข้าถึงข้อมูลแผนที่ฐานและระบบไฟฟ้าของการไฟฟ้านครหลวง ในรูปแบบ Data Service และ Map Service",
  SubtitlesDataService:
    "Data Service คือข้อมูลที่การไฟฟ้านครหลวงให้บริการทั้งข้อมูลระบบไฟฟ้าและข้อมูลแผนที่ฐาน ",
  SubtitlesMapService:
    "Map Service  สำหรับให้บริการข้อมูลระบบไฟฟ้าของการไฟฟ้านครหลวงในรูปแบบของ Vector Tiles และ Raster Tiles",
  SubtitlesHowtouseAPI: "",
  // SubtitlesGetStartNow: "ลงทะเบียนเพื่อใช้บริการ",
  SubtitlesGetStartNow: "",
  SubtitlesFooter: "ระบบให้บริการข้อมูลแผนที่ระบบไฟฟ้า",

  //subservice
  SubtitlesService:
    "นำข้อมูลแผนที่และข้อมูลระบบไฟฟ้าของการไฟฟ้านครหลวงไปติดตั้งในเว็บไซต์ของคุณโดยเรียกใช้ผ่าน MEA Maps API และสร้างบริการต่อยอดขึ้นมาเองได้ง่ายๆ ในไม่กี่ขั้นตอน",
  Subtitles2Service: "",
  SubtitlesDataServiceHave: "",
  SubtitlesMapServiceHave: "",
  SubtitlesPremiumAPI: "",
  SubtitlesPremiumAPI1: "",
  SubtitlesPremiumAPI2: "",
  SubtitlesPremiumAPI3: "",
  SubtitlesDataAPI: "",
  SubtitlesElectricDataAPI: "",
  SubtitlesLandbaseMapAPI: "",

  //subpricing
  SubtitlesPricing:
    "Plan มีความยืดหยุ่น เลือกให้เหมาะสมกับงานของคุณ หรือปรึกษาเจ้าหน้าที่เพื่อออกแบบ Plan ที่เหมาะสมกับความต้องการของคุณได้",
  SubtitlesAllPlan: "",
  SubtitlesService1: "",
  SubtitlesService2: "",
  SubtitlesService3: "",
  SubtitlesEnterprise: "",

  //subdoc
  SubtitlesDocument: "",
  SubtitlesIntroduction:
    "ระบบให้บริการข้อมูลแผนที่ คือ บริการข้อมูลแผนที่ฐานและระบบไฟฟ้าของการไฟฟ้านครหลวง ในรูปแบบ API Service  เปิดให้บริการให้แก่ประชาชนทั่วไป หน่วยงาน องค์กรทั้งภาครัฐและเอกชน",
  SubtitlesAccesstoken: "",
  SubtitlesAPIversioning: "",
  SubtitlesRateLimits: "",

  //subpsupport
  SubtitlesSupport: "หากพบปัญหา ติดต่อทีม Support ของเรา",
  SubtitlesDoyouhavequestion:
    "คำถามเกี่ยวการใช้งานในเบื้องต้นเราได้รวบรวมเอาไว้ที่นี่ หรือเข้ามาคุยกับเราได้ที่",
  SubtitlesContactUs: "",
  SubtitlesFaq: "",

  //subwelcome
  SubtitlesWelcome: "เข้าสู่ระบบบริการข้อมูลระบบไฟฟ้าของการไฟฟ้านครหลวง",
  SubtitlesYoucanaccessAPI: "คุณสามารถเข้าถึง API ได้แก่",
  SubtitlesAPIusage: "เรียกดูประวัติการใช้งาน API",
  SubtitlesSummary:
    "สรุปค่าใช้จ่ายรายเดือนจากการเรียกใช้ Service ทั้ง Data API และ Map API",
  SubtitlesDataAPIservice: "รายชื่อ Data API service ที่ให้บริการ",

  //appbar
  HOME: "หน้าหลัก",
  SERVICE: "การบริการ",
  Service1: "Data Service",
  Service2: "Map Service",

  // Service3:"",
  PRICING: "ค่าบริการ",
  DOCUMENT: "คู่มือการใช้งาน",
  SUPPORT: "ติดต่อสอบถาม",
  Signin: "เข้าสู่ระบบ",
  Register: "สมัครเข้าใช้งาน",

  //home
  Getstart: "เริ่มต้นใช้งาน",
  Ourexclusiveservice: "รูปแบบการให้บริการ",
  Service: "การบริการ",
  About: "เกี่ยวกับ",
  Contactus: "ติดต่อเรา",
  OurApi: "บริการข้อมูลด้วย API Services",
  DataService: "Data Service",
  MapService: "Map Service",
  Address: "Address",
  Howtouse: "ขั้นตอนง่ายๆ เพื่อใช้บริการ API ของเรา",
  API: "API",
  GetStartNow: "กดปุ่ม ‘สร้างบัญชี’ เพื่อเริ่มใช้บริการ",
  CreateAccount: "สร้างบัญชีผู้ใช้งาน",
  Legal: "กฎหมาย",
  Chooseaplan: "สร้าง API Key",
  CreateProject: "เติมเงินเข้าบัญชี",
  Get: "ใช้งาน API",

  //footer
  TermCondition: "ข้อกำหนดและเงื่อนไข",
  // Privacy: "นโยบายความเป็นส่วนตัว",

  //service
  Premium: "Premium",

  //pricing
  Freetier: "Free Package",
  Payasyougo: "Pay as you go Package",
  Request: "การร้องขอ",
  Freeplan: "เริ่มต้นใช้งานฟรี",
  Orderplan: "เริ่มต้นใช้งาน",
  Contactplan: "ติดต่อเรา",
  Contact: "Enterprise Package",
  AllPlanareInclude:
    "บริการพิเศษจากการไฟฟ้านครหลวง ที่เปิดให้บริการสำหรับทุก Plan",
  Enterprise: "สำหรับลูกค้าที่เป็นลูกค้าองค์กรภายนอก โปรดระบุรายละเอียด",
  SendMessage: "ส่งข้อมูลเพื่อบอกความต้องการของคุณ",

  //document
  Introduction: "แนะนำการใช้งาน",
  Vector: "เวกเตอร์",
  Raster: "ราสเตอร์",
  Parameter: "ตัวแปร",
  Example: "Example",
  Value: "Value",
  Description: "คำอธิบาย",
  Code: "รหัส",
  LandmarkPoint: "สถานที่สำคัญ",
  DistrictPoly: "เส้นขอบเขตการไฟฟ้าเขต",
  LandmarkLine: "เส้นขอบเขตสถานที่สำคัญ",
  CenterLine: "เส้นกึ่งกลางถนน",
  RoadEdge: "เส้นขอบเขตถนน",
  Building: "อาคาร",
  BuildingLine: "เส้นแบ่งอาคาร",
  Hydrology: "แม่น้ำ",
  Capacitor: "ตัวเก็บประจุ",
  cctv: "กล้องวงจรปิด",
  DuctBank: "แนวท่อร้อยสายใต้ดิน",
  FiberOpticCable: "สายสื่อสาร",
  Fuse: "Fuse",
  Ground: "Ground",
  GroundMeter: "มิเตอร์กลุ่ม",
  HighTensionMeter: "มิเตอร์ไฟฟ้าแรงสูง",
  InlineEquipment: "อุปกรณ์ประกอบสาย",
  LightningArrestor: "ตัวป้องกันฟ้าผ่า",
  LowVoltageMeter: "มิเตอร์ไฟฟ้าแรงต่ำ",
  Manhole: "Manhole",
  Meterline: "Meter line",
  Meterlink: "Meter link",
  OverheadHighVoltageConductor: "สายไฟฟ้าอากาศแรงสูง",
  OverheadLowVoltageConductor: "สายไฟฟ้าอากาศแรงต่ำ",
  OverheadLowVoltageConductorUnder: "สายไฟฟ้าแรงต่ำใต้อาคาร",
  OverheadMediumVoltageConductor: "สายไฟฟ้าอากาศแรงกลาง",
  OverheadStreetlightVoltageConductor: "สายอากาศไฟฟ้าสาธารณะ",
  Pole: "เสาไฟฟ้า",
  SpanGuy: "Guy",
  Splice: "Splice",
  Streetlight: "ดวงโคมไฟฟ้าสาธารณะ",
  StreetlightControl: "อุปกรณ์ควบคุมไฟฟ้าสาธารณะ",
  Switche: "สวิตซ์",
  Transformer: "Transformer",
  UndergroundHighVoltageConductor: "สายไฟฟ้าใต้ดินแรงสูง",
  UndergroundLowVoltageConductor: "สายไฟฟ้าใต้ดินแรงต่ำ",
  UndergroundMediumVoltageConductor: "สายไฟฟ้าใต้ดินแรงกลาง",
  UndergroundStreetlightVoltageConductor: "สายใต้ดินไฟฟ้าสาธารณะ",
  Circuitbreaker: "เซอร์กิตเบรคเกอร์",
  Streetlightinlineequipment: "อุปกรณ์ประกอบสายไฟฟ้าสาธารณะ",
  Riser: "เสาต้นขึ้นหัวสายเคเบิลใต้ดิน",
  SubstationTransformer: "หม้อแปลงไฟฟ้าย่อย",
  Switchgear: "สวิตช์เกียร์",
  LandBaseDataAPI: "ข้อมูลแผนที่ฐาน",
  ElectricDataAPI: "ข้อมูลแผนที่ระบบไฟฟ้า",
  LandBaseAPI: "แผนที่ฐาน",
  ElectricAPI: "แผนที่ระบบไฟฟ้า",
  RateLimits: "อัตราขีดจำกัด",
  ResponseMessages: "ข้อความตอบกลับ",
  Versioning: "เวอร์ชัน",
  Howto1: "1. กดปุ่ม Authorize เพื่อใส่ API Key",
  Howto2: '2. เลือก endpoint ต้องการ เช่น "อาคาร"',
  Howto3: "3. กดปุ่ม Try it out เพื่อทดลองใช้งาน API",
  Howto4: "4. ปรับแต่ง พารามิเตอร์ตามผลลัพธ์ที่ต้องการ",
  Howto5: "5. กดปุ่ม Execute เพื่อดูผลลัพธ์",
  Badrequest: "คำขอผิดพลาด",
  Unauthorized: "ไม่มีสิทธิเข้าถึง",
  Forbidden: "ไม่ได้รับอนุญาต",
  Proxy: "จำเป็นต้องมีการตรวจสอบสิทธิ์พร็อกซี",
  BadGateway: "Bad Gateway",
  GatewayTimeout: "Gateway Timeout",
  FiberOpticSystem: "ระบบไฟเบอร์ออปติก (แยกตามผู้ให้บริการ)",
  PublicSystem: "ระบบไฟฟ้าสาธารณะ",
  OnGroundSystem: "ระบบไฟฟ้าบนพื้นดิน",
  UndergroundSystem: "ระบบไฟฟ้าใต้ดิน",
  Landbase: "แผนที่ฐาน",
  Electric: "แผนที่ระบบไฟฟ้า",
  SubtitlesDescription:
    "เรียกใช้ในรูปแบบ เปลี่ยนชื่อ Endpoint จาก “landbases” เป็น Endpoint Name อื่น ๆ ตามข้อมูลต้องการ",
  DescriptionService: "การเรียกใช้งาน Map Service ชั้นข้อมูลอื่นๆ",
  UsingSCS: "การใช้งาน SCS map iframe",
  UsageParameter: "พารามิเตอร์ที่ใช้งาน",
  YourAPI: "API-key ของคุณ",
  Qparam:
    "ค่าพิกัดกึ่งกลางของแผนที่ที่ต้องการแสดง เช่น q=100.554894,13.721237 หากไม่ใส่พารามิเตอร์ ค่าเริ่มต้นจะเป็นตำเเหน่งปัจจุบันของผู้ใช้งาน",
  Zparam: "ค่า zoom level หากไม่ใส่พารามิเตอร์ ค่าเริ่มต้นจะเป็น zoom level 10",
  Typeparam:
    "ประเภทของการใช้งานจะเเบ่งเป็น private และ public หากไม่ใส่พารามิเตอร์ ค่าเริ่มต้นจะเป็น public",
  Mtparam:
    "รูปแบบของแผนที่ฐาน มีสองประเภท คือ satellite และ vectortile หากไม่ใส่พารามิเตอร์ ค่าเริ่มต้นจะเป็น vectortile",
  SCSExample: "ตัวอย่างการใช้งาน SCS Map Iframe",
  InitDataParam: "'true' เพื่อให้ระบบส่งคืนข้อมูลเมื่อเปิดใช้งานครั้งแรก",

  //support
  Doyouhaveanyquestion: "มีข้อสงสัย ส่งคำถามหาเรา",
  Question: "คำถาม",
  Phone: "โทรศัพท์",
  Detail: "รายละเอียด",
  Submit: "ส่งข้อมูล",
  Getintouch: "สอบถามข้อมูล/แจ้งปัญหาการใช้งาน",

  //admin
  Dashboard: "ภาพรวมการใช้งาน API",
  User: "จัดการผู้ใช้งาน",
  UserName: "ชื่อผู้ใช้งาน",
  Users: "ผู้ใช้งาน",
  LimitUsage: "ปริมาณการใช้งาน",
  Report: "รายงาน",
  ApiRequest: "Requests",
  ApiKey: "API Key",
  TotalBalance: "ยอดการใช้เครดิตรวม",
  Customer: "ลูกค้า",
  TimePeriod: "ช่วงเวลา",
  From: "เริ่มต้น",
  To: "ถึง",
  Lastweek: "ย้อนหลัง 1 สัปดาห์",
  Last2week: "ย้อนหลัง 2 สัปดาห์",
  Lastmonth: "ย้อนหลัง 1 เดือน",
  Last3month: "ย้อนหลัง 3 เดือน",
  Last6month: "ย้อนหลัง 6 เดือน",
  Lastyear: "ย้อนหลัง 1 ปี",
  CustomPeriod: "ปรับแต่งช่วงเวลา",
  Moredetail: "เพิ่มเติม",
  Income: "รายได้รวม",
  Bath: "บาท",
  Organization: "หน่วยงาน",
  Type: "ประเภท",
  Status: "สถานะ",
  Key: "API Key",
  Month: "เดือน",
  Year: "ปี",
  Layer: "ชั้นข้อมูล",
  Export: "ส่งออกข้อมูล",
  Seemore: "ดูเพิ่มเติม",
  CreateUser: "เพิ่มผู้ใช้งาน",
  UserType: "ประเภทผู้ใช้",
  SearchUser: "ระบุชื่อผู้ใช้",
  Selectkeyname: "เลือก API Key",
  SelectMonth: "เลือกเดือน",
  SelectPeriod: "เลือกช่วงเวลา",
  Selectyear: "เลือกปี",
  Allmonth: "ทุกเดือน",
  Today: "วันนี้",
  Customperiod: "Custom period",
  GenApiSuccess: "สร้าง API key เรียบร้อยแล้ว",
  DeleteApiSuccess: "ลบ API key เรียบร้อยแล้ว",
  UpdateApiSuccess: "อัพเดท API key เรียบร้อยแล้ว",
  APIcopied: "คัดลอก API key แล้ว",
  Times: "ครั้ง",
  Size: "ขนาดข้อมูล",
  KB: "กิโลไบต์",

  //user
  Welcome: "ยินดีต้อนรับ",
  APIUsage: "ประวัติการใช้งาน",
  Summary: "สรุป",
  Payment: "การชำระเงิน",
  Period: "ระยะเวลา",
  Generate: "สร้าง",
  CreateAt: "สร้างล่าสุดเมื่อ",
  LastUpdate: "อัพเดตล่าสุดเมื่อ",
  Createkeyname: "ตั้งชื่อ API key",
  Cost: "ค่าบริการ",
  Apply: "นำไปใช้",
  Total: "รวม",
  THB: "บาท",
  Invoice: "ใบแจ้งหนี้",
  Monthlyexpendituresummary: "สรุปค่าใช้จ่ายรายเดือน",
  PersonalInfo: "ข้อมูลส่วนตัว",
  BillingInfo: "ที่อยู่เพื่อออกใบเสร็จรับเงิน",
  Start: "เริ่ม",
  End: "สิ้นสุด",
  Addusersuccess: "เพิ่มผู้ใช้เรียบร้อยแล้ว",
  Updateusersuccess: "แก้ไขผู้ใช้เรียบร้อยแล้ว",
  Deleteusersuccess: "ลบผู้ใช้เรียบร้อยแล้ว",
  OldPassword: "รหัสผ่านเดิม",
  NewPassword: "รหัสผ่านใหม่",
  EnableUser: "เปิดใช้งานผู้ใช้แล้ว",
  DisableUser: "ปิดใช้งานผู้ใช้แล้ว",
  CreateKeyName: "",
  For: "จาก",
  ChangePassword: "เปลี่ยนรหัสผ่าน",
  Tax: "เลขประจำตัวผู้เสียภาษี",
  Add: "เพิ่ม",
  OK: "OK",
  AddCredit: "เพิ่มเครดิต",
  YourTotalCredits: "ยอดเครดิตทั้งหมดของคุณ",
  InsertCredit: "กรอกจำนวนเครดิต",
  Amount: "จำนวน",
  AllType: "ทุกประเภท",
  Keyname: "ชื่อ API key",
  ApplicationRestriction: "ข้อจำกัดของแอปพลิเคชัน",
  None: "ไม่มี",
  AppResDetail:
    "การจำกัดการใช้งานแอปพลิเคชันด้วยการระบุเว็บไซต์, หมายเลข IP, หรือแอปพลิเคชัน ที่เรียกใช้ APIคีย์ของคุณได้ คุณสามารถตั้งค่านี้ได้แบบหนึ่งแอปพลิเคชัน ต่อ APIคีย์",
  HTTPReferrers: "HTTP referrer",
  IPaddress: "หมายเลข IP",
  Web: "เว็บไซต์",
  Server: "เซิร์ฟเวอร์",
  etc: "ฯลฯ",
  Websiterestrictions: "ข้อจำกัดเว็บไซต์",
  Updatekey: "แก้ไข API key",
  Deletekey: "ลบ API key",
  EnableAPI: "เปิดใช้งาน API Key",
  Restrictusage: "จำกัดคำขอการใช้งาน API key ตามเว็บไซต์ที่ระบุ",
  AcceptrequestIP: "ยอมรับคำขอจากหมายเลข IP ของเซิร์ฟเวอร์เหล่านี้",
  SpecifiedIP:
    "ระบุ IPv4 IPv6 หรือซับเน็ตโดยใช้รูปแบบ CIDR (เช่น 192.168.0.0/22) ตัวอย่าง : 192.168.0.1,172.16.0.0 // 12,2001:db8:1 หรือ db8:/64",
  Confirmkeydelete: "ยืนยันชื่อ API key เพื่อดำเนินการต่อ",
  DialogAddCredit: "คุณต้องการจะเพิ่มเครดิตจำนวน",
  PleaseOk: 'กด "OK" เพื่อยืนยันจำนวนการเติมเครดิต',
  DeleteUser: "ลบผู้ใช้",
  ConfirmNameUser: "ยืนยัน ชื่อ - นามสกุล ผู้ใช้เพื่อดำเนินการต่อ",
  Addcreditssuccessfully: "เพิ่มเครดิตเรียบร้อยแล้ว",
  Cannotdeleteuser: "ไม่สามารถลบผู้ใช้",
  CantCreateAPIkeymore: "ไม่สามารถสร้าง API key เพิ่มได้",

  //login
  Getmorething: "รับสิ่งต่าง ๆ มากขึ้นเพียงลงชื่อเข้าใช้",
  Donthaveaccount: "ไม่มีบัญชีผู้ใช้งานใช่ไหม",
  Createhere: "สร้างบัญชีที่นี่",
  CreateAccessService: "สร้างบัญชีเพื่อใช้บริการข้อมูลการไฟฟ้า",
  Alreadyaccount: "มีบัญชีผู้ใช้งานแล้ว",
  UsePersonalInformation: "ใช้ข้อมูลส่วนตัวเป็นข้อมูลที่อยู่ออกใบเสร็จรับเงิน",
  ForgotPassword: "ลืมรหัสผ่านหรือไม่ ?",
  EnterEmail:
    "กรอกอีเมลของคุณที่ใช้ลงทะเบียนด้านล่างนี้ ระบบฯจะส่งลิงก์ไปให้คุณเพื่อรีเซ็ตรหัสผ่าน",
  SendEmail: "ส่งอีเมล",
  ResetPassword: "รีเซ็ตรหัสผ่าน",
  ResetYourPassword: "รีเซ็ตรหัสผ่านของคุณ",
  PasswordNotMatch: "รหัสผ่านไม่ตรงกัน",
  Password8: "รหัสผ่านของคุณต้องมีอย่างน้อย 8 ตัวอักษร",
  ResetPasswordSuccess: "รีเซ็ตรหัสผ่านเรียบร้อยแล้ว",
  CheckEmail: "ตรวจสอบอีเมลของคุณ เพื่อดำเนินการรีเซ็ตรหัสผ่าน",

  //limit usage
  Usage: "การใช้งาน",
  Setting: "ตั้งค่า",
  DefineService: "กำหนด Service",
  ServiceManage: "จัดการ Service",
  All: "ทั้งหมด",
  AddmoreData: "เพิ่มบริการข้อมูลอิเล็กทรอนิกส์ API",
  AddmoreMap: "เพิ่มบริการข้อมูลแผนที่อิเล็กทรอนิกส์ API",
  ElectronicDataAPI: "บริการข้อมูลอิเล็กทรอนิกส์ API",
  ElectronicMapAPI: "บริการข้อมูลแผนที่อิเล็กทรอนิกส์ API",
  RemoveDialog: "คุณต้องการที่จะลบ",
  RemoveelectronicdataAPI: "ลบข้อมูลอิเล็กทรอนิกส์",
  RemoveelectronicmapAPI: "ลบข้อมูลแผนที่อิเล็กทรอนิกส์",
  Ownerlist: "รายชื่อเจ้าของ",
  SelectOwner: "เลือกเจ้าของ fiber - optic ",
  NoService: "ไม่มีบริการ",
  Manageservicesuccess: "จัดการบริการสำเร็จ",
  of: "จาก",
  Updatefiber: "จัดการ fiber-obtic สำเร็จ",
  addservice: "เพิ่มบริการสำเร็จ",
  RemoveService: "ลบ service สำเร็จ",
  RemoveServiceError: "ลบ service ไม่สำเร็จ",
  Credits: "ยอดเครดิต",

  //Our Exclusive Service
  Exclusive_Service_Data_Service: "บริการข้อมูลแผนที่ฐานและข้อมูลระบบไฟฟ้า",
  Exclusive_Service_Map_Service: "บริการแผนที่ฐานและแผนที่ระบบไฟฟ้า",
  sendMailSuccess: "ส่งอีเมลสำเร็จ",
  sendMailError: "ส่งอีเมลล้มเหลว",
};
